import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c3ff0f46"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "UserManagementBox" }
const _hoisted_2 = { class: "operationCont" }
const _hoisted_3 = { class: "UserManagement-table" }
const _hoisted_4 = { class: "paginationCont" }
const _hoisted_5 = { class: "dialogBox" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"red"} }, "*"),
  /*#__PURE__*/_createTextVNode(" APP功能权限：")
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"red"} }, "*"),
  /*#__PURE__*/_createTextVNode(" PC功能权限：")
], -1))
const _hoisted_8 = { class: "dialog-footer" }

import {
  ref,
  reactive,
  onMounted,
  getCurrentInstance,
  toRaw,
  nextTick,
  onUnmounted,
  watch
} from "vue";
import { getListCompanyInfo } from "@/views/Login/api";
import { FormInstance, FormRules, ElMessage } from "element-plus";
import { useRouter } from "vue-router";
import { setField } from "@/utiles/utiles";
import { useStore } from "vuex";
import { Search, RefreshRight, Plus } from "@element-plus/icons-vue";
import { ElTree } from "element-plus";
import type Node from "element-plus/es/components/tree/src/model/node";
import {
  getPage,
  getDeptTree,
  saveOrUpdate,
  updateEnableFlag,
  queryMenuByRole,
} from "./api.js";

interface Tree {
  name: string;
}
interface ruleFormConfigItem {
  id: string;
  roleName: string;
  menuIds: any[];
  roleAuth: any[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

let count = 1;
let userInfo = sessionStorage.getItem("userInfo")
  ? JSON.parse(sessionStorage.getItem("userInfo") || "")
  : "";
const props = {
  label: "label",
  children: "children",
};
const defaultProps = {
  label: "label",
  children: "children",
};
const talentArr = ref<any>([]);
const store = useStore();
const loadNode = (node: Node, resolve: (data: Tree[]) => void) => {
  if (node.level === 0) {
    return resolve([{ name: "Root1" }, { name: "Root2" }]);
  }
  if (node.level > 3) return resolve([]);

  let hasChild = false;
  if (node.data.name === "region1") {
    hasChild = true;
  } else if (node.data.name === "region2") {
    hasChild = false;
  } else {
    hasChild = Math.random() > 0.5;
  }

  setTimeout(() => {
    let data: Tree[] = [];
    if (hasChild) {
      data = [
        {
          name: `zone${count++}`,
        },
        {
          name: `zone${count++}`,
        },
      ];
    } else {
      data = [];
    }

    resolve(data);
  }, 500);
};
const queryFormRef = ref<FormInstance>();
const ruleFormRef = ref<FormInstance>();
const Router = useRouter();
const pageSizes = ref([10, 20, 50]);
const hasInitialSearch = ref(false);

const userManuallySetPageSize = ref(false);
const calculateTableRows = () => {
  // 如果用户手动设置了页面大小，则不进行自动计算
  if (userManuallySetPageSize.value) {
    return;
  }
  const tableContainer = document.querySelector('.UserManagement-table');
  if (!tableContainer) {
    return;
  }

  const allRows = document.querySelectorAll('.el-table__row');
  if (!allRows.length) {
    if (!hasInitialSearch.value) {
      hasInitialSearch.value = true;
      onSearch(false);
    }
    return;
  }

  // 计算新的 pageSize
  const totalHeight = Array.from(allRows).reduce((sum, row) => {
    return sum + row.getBoundingClientRect().height;
  }, 0);
  const rowHeight = totalHeight / allRows.length;
  const containerHeight = tableContainer.clientHeight;
  const tableHeader = document.querySelector('.el-table__header');
  const headerHeight = tableHeader ? tableHeader.getBoundingClientRect().height : 0;
  const availableHeight = containerHeight - headerHeight;
  const maxRows = Math.floor(availableHeight / rowHeight);
  const calculatedSize = Math.ceil(maxRows / 5) * 5;

  // 只有当计算出的大小与当前大小不同，且不是在切换租户过程中时才更新
  if (calculatedSize !== queryForm.pageSize && !isChangingTenant.value) {
    pageSizes.value = [calculatedSize, calculatedSize * 2, calculatedSize * 3];
    defaultPageSize.value = calculatedSize;
    queryForm.pageSize = calculatedSize;
    onSearch(false);  // 使用 false 避免重置 compCode
  }
};

// 添加一个标记变量来追踪是否正在切换租户
const isChangingTenant = ref(false);

// 修改租户切换的处理
const handleTenantChange = () => {
    isChangingTenant.value = true;
    onSearch(false);
    nextTick(() => {
        isChangingTenant.value = false;
    });
};
const defaultPageSize = ref(10);
const queryForm = reactive({
  condition: {
    compCode: userInfo.compCode,
  },
  pageIndex: 1,
  pageSize: defaultPageSize.value,
});
const appTreeData = reactive(
  store.getters.menuTree.find((v: any) => v.id == "1").children
);

const pcTreeData = reactive(
  store.getters.menuTree
    .find((v: any) => v.id == "2")
    .children?.filter((m: any) => m.id !== '0' && 
      m.menuCode !== 'pc_exception_report' && 
      m.menuCode !== 'pc_task_monitor'
    )
);
const appTreeRef = ref<InstanceType<typeof ElTree>>();
const pcTreeRef = ref<InstanceType<typeof ElTree>>();
const pcCheckKeys = ref<any>([]);
const appChacKeys = ref<any>([]);
const tableData = ref<any>([]);
const deptTree = ref<any>([]);
const dialogVisible = ref(false);
let isAdmin = ref(false);
const dialogTitle = ref<string>("新增角色");
const total = ref<number>(0);
const formSize = ref("default");
const ruleForm = reactive<ruleFormConfigItem>({
  id: "",
  roleName: "",
  menuIds: [],
  roleAuth: [],
});

const rules = reactive<FormRules>({
  roleName: [{ required: true, message: "请输入角色名称", trigger: "blur" }],
  menuIds: [
    {
      required: true,
      message: "请选择岗位权限",
      trigger: "change",
    },
  ],
  roleAuth: [
    {
      required: true,
      message: "请选择登录权限",
      trigger: "change",
    },
  ],
});

const { proxy }: any = getCurrentInstance();
onMounted(() => {
  nextTick(() => {
    calculateTableRows();
  });
  let name = toRaw(Router).currentRoute.value.name;
  proxy.$doResize(name);
  getDeptTreeFn();
  // onSearch(true);
  getListCompanyInfos();
  isAdmin.value =
    (sessionStorage.getItem("userInfo")
      ? JSON.parse(sessionStorage.getItem("userInfo") || "").id
      : false) == "0";
  const debouncedCalculate = debounce(calculateTableRows, 200);
  window.addEventListener('resize', debouncedCalculate);
});
watch(tableData, () => {
    if (tableData.value.length > 0) {  // 只在有数据时才重新计算
        nextTick(() => {
            calculateTableRows();
        });
    }
}, { immediate: false });
onUnmounted(() => {
    window.removeEventListener('resize', calculateTableRows);
    userManuallySetPageSize.value = false;
});
const debounce = (fn: Function, delay: number) => {
    let timer: any = null;
    return function (this: any, ...args: any[]) {
        if (timer) clearTimeout(timer);
        timer = setTimeout(() => {
            userManuallySetPageSize.value = false; // 重置标志位
            fn.apply(this, args);
        }, delay);
    };
};
const getListCompanyInfos = () => {
  getListCompanyInfo().then((res: any) => {
    console.log(res);
    talentArr.value = res;
  });
};
const appcheckChange = (val: any) => {
  appTreeRef.value!.setCheckedKeys([], false);
};
const pccheckChange = (val: any) => {
  pcTreeRef.value!.setCheckedKeys([], false);
};
const getDeptTreeFn = () => {
  getDeptTree().then((res: any) => {
    deptTree.value = res;
  });
};
const onSearch = (type: boolean) => {
  if (type) {
    queryForm.condition.compCode = userInfo.compCode
    queryForm.pageIndex = 1;
  }
  if (!queryForm.condition.compCode) {
    queryForm.condition.compCode = userInfo.compCode
  }
  getPage(queryForm).then((res: any) => {
    const { items, totalSize } = res;
    total.value = Number(totalSize);
    tableData.value = items;
  });
};
const handleCheckChange = (
  data: Tree,
  checked: boolean,
  indeterminate: boolean
) => {
  if (appTreeRef.value!.getCheckedKeys().length > 0) {
    ruleForm.roleAuth = ["APP"];
  }
  if (pcTreeRef.value!.getCheckedKeys().length > 0) {
    ruleForm.roleAuth = ["PC"];
  }
  if (
    appTreeRef.value!.getCheckedKeys().length > 0 &&
    pcTreeRef.value!.getCheckedKeys().length > 0
  ) {
    ruleForm.roleAuth = ["APP", "PC"];
  }
};
const updateEnableFlagFn = (value: string, id: string) => {
  let param = {
    id: id,
    enableFlag: value,
  };
  updateEnableFlag(param)
    .then((res: any) => {
      ElMessage({
        type: "success",
        message: "切换成功",
      });
      onSearch(false);
    })
    .catch((err: any) => {
      onSearch(false);
    });
};

const newlyAdded = () => {
  dialogTitle.value = "新增角色";
  dialogVisible.value = true;
};
const resetForm = (formEl: FormInstance | undefined, type: boolean) => {
  if (!formEl) return;
  formEl.resetFields();
  if (type) {
    dialogVisible.value = false;
  }
};
const queryMenuByRoleRequest = (id: any) => {
  console.log("pcTreeData", pcTreeData);

  let arr =
    JSON.parse(window.localStorage.getItem("menuTree"))
      ?.filter((v: any) => v.id == "2")[0]
      ?.children.map((val: any) => val.id) || [];
  console.log("arr", arr);
  let menuTree = JSON.parse(window.localStorage.getItem("menuTree"))?.filter((v: any) => v.id == "2")[0]?.children || [];
console.log('menuTree',menuTree);

  // 收集没有子菜单的菜单项
  let single = menuTree
    .filter((item: any) => !item.children || item.children.length === 0)
    .map((item: any) => item.id);
    console.log("single",single);
    
  queryMenuByRole({ id }).then((res: any) => {
    appChacKeys.value = res;
    // 过滤出不在arr中的值以及包含在single中的值
    pcCheckKeys.value = res.filter((v: any) => {
      // 如果v在single数组中，则直接返回true（包含它）
      if (single.includes(v)) {
        return true;
      }
      // 如果arr有长度并且v不在arr中，返回true（包含它）
      if (arr.length && !arr.includes(v)) {
        return true;
      }
      // 其他情况返回false（不包含它）
      return false;
    });

    console.log("pcCheckKeys", pcCheckKeys);
  });
};
const edit = async (row: any) => {
  dialogTitle.value = "编辑角色";
  dialogVisible.value = true;
  await nextTick();
  await queryMenuByRoleRequest(row.id);
  setTimeout(() => {
    for (let key in row) {
      const k = key as keyof ruleFormConfigItem;
      setField(ruleForm, k, row[k]);
    }
    if (row.roleAuth == "ALL") {
      ruleForm.roleAuth = ["APP", "PC"];
    } else {
      ruleForm.roleAuth = [row.roleAuth];
    }
    console.log(row, "row");
    console.log(ruleForm);
  }, 200);
};
const handleSizeChange = (val: number) => {
  userManuallySetPageSize.value = true; // 设置标志位表示用户手动修改了页面大小
  queryForm.pageSize = val;
  queryForm.pageIndex = 1
  onSearch(false);
};
const handleCurrentChange = (val: number) => {
  queryForm.pageIndex = val;
  onSearch(false);
};
const flatPromissRouter = (arr: any[]) => {
  return arr.map((v: any) => {
    if (Array.isArray(v.children)) {
      return [...flatPromissRouter(v.children), v.id];
    }
    return v.id;
  });
};
const handleClose = (formEl: any) => {
  if (!formEl) return;
  formEl.resetFields();
  ruleForm.id = "";
  appTreeRef.value!.setCheckedKeys([], false);
  pcTreeRef.value!.setCheckedKeys([], false);
};
const submitForm = async (formEl: FormInstance | undefined) => {
  if (!formEl) return;
  await formEl.validate((valid: any, fields: any) => {
    if (valid) {
      let param = { ...ruleForm, compCode: queryForm.condition.compCode };
      let roleAuth = [];
      if (param.roleAuth.length == 1) {
        roleAuth = param.roleAuth;
      } else {
        roleAuth = ["ALL"];
      }
      param.roleAuth = roleAuth[0];
      // param.menuIds = Array.from(new Set([...appTreeRef.value!.getCheckedNodes().map(v=>v.id),...pcTreeRef.value!.getCheckedNodes().map(v=>v.id),...flatPromissRouter(appTreeRef.value!.getHalfCheckedNodes()).flat(2),...flatPromissRouter(pcTreeRef.value!.getHalfCheckedNodes()).flat(2)]))
      // console.log('pcTreeRef.value!.getCheckedNodes().map(v=>v.id)', )
      param.menuIds = Array.from(
        new Set([
          ...appTreeRef.value!.getCheckedNodes().map((v) => v.id),
          ...pcTreeRef
            .value!.getCheckedNodes()
            .map((v) => {
              if (v.pid != "2") {
                return [v.id, v.pid];
              } else {
                return [v.id];
              }
            })
            .flat(2),
        ])
      );
      console.log("params", param);
      // return
      if (param.menuIds.length == 0) {
        ElMessage({
          type: "error",
          message: "请选择登录权限",
        });
        return;
      }
      saveOrUpdate(param).then((res: any) => {
        ElMessage({
          type: "success",
          message: dialogTitle.value + "成功",
        });
        onSearch(false);
        dialogVisible.value = false;
      });
    } else {
      console.log("error submit!", fields);
    }
  });
};

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_form, {
        inline: true,
        model: queryForm,
        class: "demo-form-inline",
        ref_key: "queryFormRef",
        ref: queryFormRef
      }, {
        default: _withCtx(() => [
          (_unref(userInfo).id === '0')
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 0,
                label: "租户",
                prop: "compCode"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: queryForm.condition.compCode,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((queryForm.condition.compCode) = $event)),
                    placeholder: "请选择",
                    onChange: handleTenantChange
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(talentArr.value, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.compCode,
                          label: item.compName,
                          value: item.compCode
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                type: "primary",
                icon: _unref(Plus),
                onClick: newlyAdded
              }, {
                default: _withCtx(() => [
                  _createTextVNode("新 增")
                ]),
                _: 1
              }, 8, ["icon"]),
              _createVNode(_component_el_button, {
                plain: "",
                icon: _unref(RefreshRight),
                onClick: _cache[1] || (_cache[1] = ($event: any) => (onSearch(true)))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("刷 新")
                ]),
                _: 1
              }, 8, ["icon"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_el_table, {
        data: tableData.value,
        border: "",
        style: {"width":"100%"},
        height: "100%",
        onRowMounted: calculateTableRows
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            type: "index",
            label: "序号",
            width: "60",
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            prop: "roleName",
            label: "角色名称",
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            prop: "roleAuth",
            label: "登录权限",
            align: "center"
          }),
          (_unref(isAdmin))
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 0,
                prop: "compCode",
                label: "归属租户代码",
                align: "center"
              }))
            : _createCommentVNode("", true),
          (_unref(isAdmin))
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 1,
                prop: "compName",
                label: "归属租户名称",
                align: "center"
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_el_table_column, {
            prop: "created",
            label: "创建时间",
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            prop: "userName",
            label: "创建人",
            align: "center",
            width: "100"
          }),
          _createVNode(_component_el_table_column, {
            fixed: "right",
            label: "操作",
            width: "120",
            align: "center"
          }, {
            default: _withCtx((scope) => [
              _createVNode(_component_el_button, {
                link: "",
                type: "primary",
                size: "small",
                onClick: _withModifiers(($event: any) => (edit(scope.row)), ["prevent"])
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 编 辑 ")
                ]),
                _: 2
              }, 1032, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_el_pagination, {
        background: "",
        layout: "total, sizes, prev, pager, next",
        "page-sizes": pageSizes.value,
        total: total.value,
        "current-page": queryForm.pageIndex,
        "onUpdate:current-page": _cache[2] || (_cache[2] = ($event: any) => ((queryForm.pageIndex) = $event)),
        "page-size": queryForm.pageSize,
        "onUpdate:page-size": _cache[3] || (_cache[3] = ($event: any) => ((queryForm.pageSize) = $event)),
        onSizeChange: handleSizeChange,
        onCurrentChange: handleCurrentChange
      }, null, 8, ["page-sizes", "total", "current-page", "page-size"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_el_dialog, {
        modelValue: dialogVisible.value,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((dialogVisible).value = $event)),
        title: dialogTitle.value,
        width: "500px",
        onClose: _cache[9] || (_cache[9] = ($event: any) => (handleClose(ruleFormRef.value))),
        "close-on-click-modal": false
      }, {
        footer: _withCtx(() => [
          _createElementVNode("span", _hoisted_8, [
            _createVNode(_component_el_button, {
              onClick: _cache[6] || (_cache[6] = ($event: any) => (resetForm(ruleFormRef.value, true)))
            }, {
              default: _withCtx(() => [
                _createTextVNode("取 消")
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (submitForm(ruleFormRef.value)))
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 确 定 ")
              ]),
              _: 1
            })
          ])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_el_form, {
            ref_key: "ruleFormRef",
            ref: ruleFormRef,
            model: ruleForm,
            rules: rules,
            "label-width": "80px",
            class: "demo-ruleForm",
            size: formSize.value,
            "status-icon": ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                label: "角色名称",
                prop: "roleName"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: ruleForm.roleName,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((ruleForm.roleName) = $event)),
                    maxlength: "10",
                    placeholder: "请输入角色名称"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "登录权限",
                prop: "roleAuth"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_checkbox_group, {
                    modelValue: ruleForm.roleAuth,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((ruleForm.roleAuth) = $event))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_checkbox, { label: "APP" }, {
                        default: _withCtx(() => [
                          _createTextVNode("APP登录")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_checkbox, { label: "PC" }, {
                        default: _withCtx(() => [
                          _createTextVNode("PC登录")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_row, { class: "elRow" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, {
                        label: "",
                        prop: "roleAuth"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_6,
                          _createVNode(_unref(ElTree), {
                            ref_key: "appTreeRef",
                            ref: appTreeRef,
                            onCheckChange: handleCheckChange,
                            "default-checked-keys": appChacKeys.value,
                            data: appTreeData,
                            "show-checkbox": "",
                            "default-expand-all": "",
                            "node-key": "id",
                            "highlight-current": "",
                            props: defaultProps
                          }, null, 8, ["default-checked-keys", "data"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, {
                        label: "",
                        prop: "roleAuth"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_7,
                          _createVNode(_unref(ElTree), {
                            ref_key: "pcTreeRef",
                            ref: pcTreeRef,
                            "default-checked-keys": pcCheckKeys.value,
                            onCheckChange: handleCheckChange,
                            data: pcTreeData,
                            "show-checkbox": "",
                            "default-expand-all": "",
                            "node-key": "id",
                            "highlight-current": "",
                            props: props
                          }, null, 8, ["default-checked-keys", "data"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model", "rules", "size"])
        ]),
        _: 1
      }, 8, ["modelValue", "title"])
    ])
  ]))
}
}

})